<template>
  <v-container fill-height fluid class="recaptcha-container app-gradient">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card class="recaptcha-card" elevation="8">
          <!-- Header Section -->
          <v-card-title class="recaptcha-header justify-center">
            <v-icon large color="white" class="mr-2">mdi-shield-check</v-icon>
            <span class="white--text">Επαλήθευση Ασφαλείας</span>
          </v-card-title>

          <!-- Content Section -->
          <v-card-text class="text-center py-6">
            <p class="subtitle-1 grey--text text--darken-1 mb-4">
              Παρακαλούμε επιβεβαιώστε ότι δεν είστε ρομπότ
            </p>

            <!-- reCAPTCHA Widget Container -->
            <div class="recaptcha-widget-wrapper">
              <VueRecaptcha
                v-if="siteKey"
                :sitekey="siteKey"
                ref="vueRecaptcha"
                @verify="verify"
                @expired="expired"
                class="g-recaptcha"
              >
              </VueRecaptcha>
            </div>

            <!-- Success Message (shown after verification) -->
            <v-fade-transition>
              <div v-if="captchaVerified" class="success-message mt-4">
                <v-icon color="success" class="mr-1">mdi-check-circle</v-icon>
                <span class="success--text">Επιτυχής επαλήθευση!</span>
              </div>
            </v-fade-transition>
          </v-card-text>

          <!-- Footer Section -->
          <v-divider></v-divider>
          <v-card-actions class="recaptcha-footer justify-center py-3">
            <v-icon small color="grey" class="mr-1">mdi-lock</v-icon>
            <span class="caption grey--text">
              Προστατεύεται από το Google reCAPTCHA
            </span>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import requests from "@/requests";

export default {
  components: { VueRecaptcha },
  name: "Recaptcha",
  data: () => ({
    siteKey: "", // pilotiko: 6LcOpw8jAAAAAEQMNDrp3xjSiWgaMaqq3Pckw1YR  | localhost:6LeQxQ8jAAAAAFy-FaU5B8HnbVUEn4b5v9pnd6qo
    captchaVerified: false,
    verifying: false,
    valid: false,
  }),

  methods: {
    reset() {
      this.$refs.vueRecaptcha.execute();
    },

    /**
     * Called when the user completes the reCAPTCHA challenge.
     * The `response` parameter is the token string provided by Google's widget.
     * We send it to the backend for server-side verification before trusting it.
     */
    verify(response) {
      this.verifying = true;

      requests.post(
        "rest/courses-books/verify-recaptcha",
        { token: response },
        () => {
          // Backend confirmed the token is valid
          this.captchaVerified = true;
          this.verifying = false;
          this.$store.commit("setRecaptchaVerified", true);
          localStorage.setItem("recaptcha_verified", "true");
          this.$router.push("/");
        }
      );
    },

    expired() {
      this.captchaVerified = false;
      this.$store.commit("setRecaptchaVerified", false);
      localStorage.removeItem("recaptcha_verified");
    },
  },
  created() {
    if (window.location.host === "demo.eudoxus.gr") {
      this.siteKey = "6LctV2csAAAAAFb87P0CzkdjBwi9EIC3APLUwZI3";
    } else if (window.location.host === "service.eudoxus.gr") {
      this.siteKey = "6Lcsg2csAAAAAGF-RB09cMog9JAcMeGLkshYZx8c";
    } else {
      this.siteKey = "6LdNonksAAAAALx1uQJA3ThlGeE606UMfRpOMhhr";
    }
  },
};
</script>

<style scoped>
.recaptcha-container {
  min-height: 100vh;
}

.recaptcha-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.recaptcha-header {
  background: linear-gradient(90deg, #1976d2 0%, #1565c0 100%);
  padding: 20px !important;
}

.recaptcha-widget-wrapper {
  display: inline-flex;
  justify-content: center;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.recaptcha-widget-wrapper:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #1976d2;
}

.success-message {
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.recaptcha-footer {
  background-color: #fafafa;
}

/* Ensure the reCAPTCHA widget is centered */
.g-recaptcha {
  display: flex;
  justify-content: center;
}
</style>
